<template>
    <div>
        <header class="header-wrapper">
            <div class="header-box">
                <div class="container">
                    <div class="row">
                        <div class="col">
                            <header-nav></header-nav>
                        </div>
                    </div>
                </div>
            </div>
            <h1 class="h1-title text-center mt-5 mb-5">{{$t('meta.privacy_policy.h1')}}</h1>
        </header>

        <main class="main-box">
            <div class="container">
                <privacy-policy-content></privacy-policy-content>
            </div>
        </main>

        <try-it-section></try-it-section>

        <footer-component></footer-component>
    </div>
</template>

<script>
    import PrivacyPolicyContent from '~cp/PrivacyPolicyContent'
    import TryItSection from '~cp/Public/PublicComponets/TryItSection.vue'
    export default {
        name: 'PrivacyPolicyPage',
        components: {
            PrivacyPolicyContent,
            TryItSection
        },
        beforeRouteEnter(from, to, next) {
            next((vm) => vm.$store.dispatch('changeStylesSpecialPage', 'additional-service'))
        },
        beforeRouteLeave(from, to, next) {
            this.$store.dispatch('changeStylesSpecialPage', '').then(() => next())
        },
        metaInfo() {
            return {
                title: this.$t('meta.privacy_policy.title'),
                meta: [
                    { vmid: 'description', name: 'description', content: this.$t('meta.privacy_policy.description') },
                ]
            }
        },
    }

</script>



// WEBPACK FOOTER //
// src/components/Public/PrivacyPolicyPage.vue